export default [
  {
    name: 'Reformer Pilates',
    imgSrc: '/images/761a0397_UR4uf.jpg',
    imgAltText: 'A room with reformer henchman equipment',
    description:
      'Reformer Pilates is a moving platform dedicated to Pilates practice, a guided class using the resistance of springs, along with your body weight for control and tone flow.  Reformer Pilates is the ultimate game changer for workouts.  This can be used in a clinical way to reshape and restore the body to the ultimate functionality, but also using the reformer as a tool to work as one with the body. The reformer has not changed since the original design from Joseph Pilates, with many makes and models, but ultimately the equipment is universal by design hence the Universal Reformer.'
  },
  {
    name: 'Mat Work',
    imgSrc: '/images/761a0273_4n0go.jpg',
    imgAltText: 'Setup with mats and equipment',
    description: 'Mat work is fundamental for all Pilates practice, we use a simple mat on the floor with small equipment to use with the body for resistance.'
  },
  {
    name: 'Clinical Pilates',
    imgSrc: '/images/761a0855_gMKKd.jpg',
    imgAltText: 'A client exercising whilst being adjusted by Jean',
    description: 'This is a term used to help with any body issues.  We use the stable platform to help stabilize the body with the springs to restore strength with resistance.  We also use this for pre and post-op.'
  },
  {
    name: 'Roller Class',
    imgSrc: '/images/761a0570_IzjT7.jpg',
    imgAltText: 'A class exercising with equipment',
    description: 'Roller is a tool we use to release facia and muscle tightness.  This class guides you through the body safely for home practice and self care.'
  }
  // {
  //   name: 'Apparatus Classes',
  //   imgSrc: '/images/761a0677_xhz8v.jpg',
  //   imgAltText: 'Clients exercising whilst being taught by Jean',
  //   description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
  // },
  // {
  //   name: 'Group Reformer Classes',
  //   imgSrc: '/images/761a0303_Vekcm.jpg',
  //   imgAltText: 'A mechanic performing air conditioning service',
  //   description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
  // }
  // {
  //   name: 'Battery Testing and Replacement',
  //   imgSrc: '/images/sos-64.jpg',
  //   imgAltText: 'A car battery being tested',
  //   description: 'A reliable battery is essential for starting your vehicle and powering its electrical systems. Our battery testing service will assess the health of your battery and recommend replacements if needed. We offer a range of high-quality batteries to suit different vehicle types and budgets.'

  // },
  // {
  //   name: 'Brake Inspections and Repairs',
  //   imgSrc: '/images/sos-27.jpg',
  //   imgAltText: 'A mechanic performing break repairs',
  //   description: 'Your safety depends on reliable brakes. Our brake inspections will ensure your braking system is in top condition, from brake pads and discs to hydraulic systems. If repairs are needed, our technicians will use quality parts and precise techniques to restore your brakes\' effectiveness.'
  // }
]



// WEBPACK FOOTER //
// ./src/lib/services.js